/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowFigureASquareLeftIcon16Light } from './ArrowFigureASquareLeftIcon16Light';
import { ArrowFigureASquareLeftIcon16Regular } from './ArrowFigureASquareLeftIcon16Regular';
import { ArrowFigureASquareLeftIcon16Solid } from './ArrowFigureASquareLeftIcon16Solid';
import { ArrowFigureASquareLeftIcon20Light } from './ArrowFigureASquareLeftIcon20Light';
import { ArrowFigureASquareLeftIcon20Regular } from './ArrowFigureASquareLeftIcon20Regular';
import { ArrowFigureASquareLeftIcon20Solid } from './ArrowFigureASquareLeftIcon20Solid';
import { ArrowFigureASquareLeftIcon24Regular } from './ArrowFigureASquareLeftIcon24Regular';
import { ArrowFigureASquareLeftIcon24Solid } from './ArrowFigureASquareLeftIcon24Solid';
import { ArrowFigureASquareLeftIcon32Regular } from './ArrowFigureASquareLeftIcon32Regular';
import { ArrowFigureASquareLeftIcon64Regular } from './ArrowFigureASquareLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowFigureASquareLeftIcon16Light,
        regular: ArrowFigureASquareLeftIcon16Regular,
        solid: ArrowFigureASquareLeftIcon16Solid,
    },
    20: {
        light: ArrowFigureASquareLeftIcon20Light,
        regular: ArrowFigureASquareLeftIcon20Regular,
        solid: ArrowFigureASquareLeftIcon20Solid,
    },
    24: {
        regular: ArrowFigureASquareLeftIcon24Regular,
        solid: ArrowFigureASquareLeftIcon24Solid,
    },
    32: {
        regular: ArrowFigureASquareLeftIcon32Regular,
    },
    64: {
        regular: ArrowFigureASquareLeftIcon64Regular,
    },
};
export var ArrowFigureASquareLeftIcon = forwardRef('ArrowFigureASquareLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
